import React from 'react';
import { Card, Alert, Empty } from 'antd';

interface IssuancePreparationStepProps {
  module: string | null;
  projectCode: string;
}

const IssuancePreparationStep: React.FC<IssuancePreparationStepProps> = ({
  module,
  projectCode,
}) => {
  if (!module) {
    return (
      <Alert
        message="请选择要操作的发行准备模块"
        description="请从左侧导航中选择具体的准备模块"
        type="info"
        showIcon
      />
    );
  }

  return (
    <Card title={`发行准备 - ${module}`}>
      <Alert
        message="暂无内容"
        description={`模块 "${module}" 暂无可用内容`}
        type="info"
        showIcon
      />
    </Card>
  );
};

export default IssuancePreparationStep;
